import { MobilePhoneOutlined as MobilePhone48PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/MobilePhoneOutlined";
import { TabletOutlined as Tablet48PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TabletOutlined";
import { SmartWatchOutlined as SmartWatch48PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/SmartWatchOutlined";
import { LaptopOutlined as Laptop48PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/LaptopOutlined";

const DeviceIcon = ({ category }: { category: string }) => {
  switch (category) {
    case "Phones":
      return <MobilePhone48PxOutlinedIcon size="extra-large" />;
    case "Tablets":
      return <Tablet48PxOutlinedIcon size="extra-large" />;
    case "Watches":
      return <SmartWatch48PxOutlinedIcon size="extra-large" />;
    case "Macs":
      return <Laptop48PxOutlinedIcon size="extra-large" />;
    default:
      return null;
  }
};

export default DeviceIcon;
